



export function GroupCard({title,syms}){


    return(
        <>

        <div className="card3cssd">
            <div className="fjsflex53535 djshfsu55523ndnnn">

                <div className="itemone itemtit  kjfhdfdbfright">
                    {title}

                </div>

                <div className="itemtwo itemtit fjsflex53535 ">
                    قیمت
                 

                </div>


                <div className="itemthree itemtit just-center">
                    تغییرات 24h

                </div>


            </div>

            <div className="contentgroupc42">
                {syms.map((sym,index)=>
                    <div className={`fjsflex53535 all45633refg ${index == 3 ? 'bb-0' : ''}`}>

                        <div className={`itemone itemsgg434`} >
                        <a class="media " href={`/${sym['symbol'].split('-')[0]}`}><img class="imgsmall " src={`https://static.sinatether.com/CoinsImg/${sym['symbol'].split('-')[0]}.png`} alt=""/><span class="text-large tt0562 pl-2"><span class="coin-name2424">{sym['persionName'].length >=12 ? `${sym['persionName'].slice(0,12)}..`: sym['persionName']} </span><span class="text-medium text-muted ">{sym['symbol'].split('-')[0]} </span></span><div class="media-body text-large"></div></a>
                        </div>
                        <div className="itemtwo itemsgg434 pptksns">

                        {new Intl.NumberFormat("fa",{maximumFractionDigits:sym['BuyIrt']>1? 3 : 8}).format(sym['BuyIrt'])}


                        </div>

                        <div className={`itemthree itemsgg434 text-center ${sym['changeRate']>=0 ? 'range-success' : 'range-red'}`}>

                        <span
                            className={'text-medium priceTt text-center '}>
                            {sym['changeRate']>=0 ?
                                <>


                                    <svg id="up.0f59dd92" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
                                    <path id="Path_1" data-name="Path 1" d="M16,0H0V16H16Z" fill="rgba(255,255,255,0.01)"/>
                                    <path id="Path_2" data-name="Path 2" d="M13.668,9V5h-4" fill="none" stroke="#29cd97" stroke-width="1.333"/>
                                    <path id="Path_3" data-name="Path 3" d="M2,12.333,5.446,8.167l3.282,2L13.667,5" fill="none" stroke="#06a969" stroke-width="1.333"/>
                                    </svg>


                            <span className={'text-success pl-1 fontjdffddfdfdfrtt'}>
                                {sym['changeRate']}%

                            </span>
                                    </>

                                :

                                <>






                        <svg id="down.75125799" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
                        <path id="Path_4" data-name="Path 4" d="M16,16H0V0H16Z" fill="rgba(255,255,255,0.01)"/>
                        <path id="Path_5" data-name="Path 5" d="M13.668,7v4h-4" fill="none" stroke="#f5455b" stroke-width="1.333"/>
                        <path id="Path_6" data-name="Path 6" d="M2,3.667,5.446,7.833l3.282-2L13.667,11" fill="none" stroke="#f5455b" stroke-width="1.333"/>
                        </svg>



                            <span className={'text-danger pl-1 fontjdffddfdfdfrtt'}>
                                {-1 * Number(sym['changeRate'])}%

                            </span>


                                </>
                            }
                        </span>

                        </div>
                        </div>

                )}

               

                
                





            </div>
        </div>
        
        </>
    )
}